import { render, staticRenderFns } from "./searchResult.vue?vue&type=template&id=07480c90&scoped=true&"
import script from "./searchResult.vue?vue&type=script&lang=js&"
export * from "./searchResult.vue?vue&type=script&lang=js&"
import style0 from "./searchResult.vue?vue&type=style&index=0&id=07480c90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07480c90",
  null
  
)

export default component.exports